import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import template from './trusted-contact.component.html';
import styles from './trusted-contact.component.scss';

@Component({
  selector: 'trusted-contact',
  template,
  styles: [styles],
})
export class TrustedContactComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }
  ngOnInit() {
    const steps = this.flowManager.getStepArrays('trusted-contact');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    if (this.form.stepsToComplete.length > 0) {
      this.form.buttons.inputs.next.path = `/${this.form.stepsToComplete[0].route}`;
      this.form.buttons.inputs.skip.path = `/${this.form.stepsToComplete[0].route}`;
    } else {
      this.form.buttons.inputs.next.path = '/submit-application';
      this.form.buttons.inputs.skip.path = '/submit-application';
    }
  }

  btnClick(e) {
    this.flowManager.isTrustedContactSkipped = e.action === 'skip';
    if (e.action === 'skip') {
      this.flowManager.resetPageError();
    }
    this.handleClick(e.action);
  }
}
